import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import CollapsibleLayout from "../layout/CollapsibleLayout";
import Dashboard from "../pages/Dashboard";
import Products from "../pages/Product/Products";
import Orders from "../pages/Order/Orders";
import Customers from "../pages/Customer/Customers";
import Settings from "../pages/Settings";
import HelpCenter from "../pages/HelpCenter";
import Report from "../pages/Report";
import Promotion from "../pages/Promotion/PromotionList";
import CmsList from "../pages/Cms/CmsList";
import AuthRedirect from "../pages/AuthRedirect";
import ProtectedRoute from "./ProtectedRoute"; // ✅ Đảm bảo bạn đã có
import Discounts from "../pages/Discount/Discounts";
import CouponList from "../pages/Coupon/CouponList";
import Album from "../pages/Album/Album";
import CollectionProducts from "../pages/Collection/CollectionProducts";
import Sales from '../pages/Sales/Sales'; 
import VoucherGame from "../pages/VoucherGame/VoucherGame";
import VouchersPage from "../pages/Voucher/VouchersPage";
const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* 👉 Nhận token từ client và chuyển sang dashboard */}
        <Route path="/auth-redirect" element={<AuthRedirect />} />

        {/* 👉 Layout chính + bảo vệ tất cả các route con */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <CollapsibleLayout />
            </ProtectedRoute>
          }
        >
          {/* 👉 Nếu chỉ vào `/` thì redirect sang dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />

          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="collections" element={<CollectionProducts />} />
          <Route path="orders" element={<Orders />} />
          <Route path="customers" element={<Customers />} />
          <Route path="settings" element={<Settings />} />
          <Route path="help-center" element={<HelpCenter />} />
          <Route path="reports" element={<Report />} />
          <Route path="promotions" element={<Promotion />} />
          <Route path="cms" element={<CmsList />} />
          <Route path="discounts" element={<Discounts />} /> 
          <Route path="coupons" element={<CouponList />} />
          <Route path="albums" element={<Album />} />
          <Route path="sales" element={<Sales />} />
          <Route path="voucher-game" element={<VoucherGame />} />
          <Route path="/admin/vouchers" element={<VouchersPage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
